import React, { Suspense } from 'react';
import AdminLayout from '../App/layout/AdminLayout/index';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from './layout/Loader';
import Aux from '../hoc/_Aux';
import ScrollToTop from './layout/ScrollToTop';
import AxiosResponseInterceptor from '../api/AxiosResponseInterceptor';
import { useStore } from 'react-redux';

const App = () => {

  const store = useStore();
  AxiosResponseInterceptor(store);

    return (
      <Aux>
        <ScrollToTop>
          <Suspense fallback={<Loader />}>
            <AdminLayout />
          </Suspense>
        </ScrollToTop>
      </Aux>
    );
}

export default App;
